module.exports = __webpack_public_path__ + "static/media/cancelled.0aa23a1c.svg";